module.exports = __webpack_public_path__ + "943ba9344c0f504686325a48058b5ec6.MP3";